import { Circle, DollarSign, BarChart2 } from "react-feather";

import {
  TRANSACTIONS_PATH,
  REFUNDS_PATH,
  RETURNS_PATH,
  CANCELLATION_POLICIES_PATH,
  INVOICES_PATH,
  PAYOUTS_PATH,
} from "@src/views/apps/financial/paths";
import {
  ANALYTICS_DASHBOARD_PATH,
  REPORTS_PATH,
  SCHEDULED_REPORTS_PATH,
  DATA_EXPORTS_PATH,
} from "@src/views/apps/analytics-reporting/paths";
import { navPerm } from "../navPermissions";
import { PERMISSION_MODULE } from "@src/utility/permissions/modulePermissions";

export default [
  {
    header: "Finance & Analytics",
  },
  {
    id: "finance",
    title: "Financial Management",
    icon: <DollarSign size={20} />,
    children: [
      {
        id: "transaction-oversight",
        title: "Transaction Oversight",
        icon: <Circle size={12} />,
        navLink: TRANSACTIONS_PATH,
        ...navPerm(PERMISSION_MODULE.TRANSACTION),
      },
      {
        id: "refunds-cancellations",
        title: "Refunds & Cancellations",
        icon: <Circle size={12} />,
        navLink: REFUNDS_PATH,
        ...navPerm(PERMISSION_MODULE.REFUND),
      },
      {
        id: "product-returns",
        title: "Product Returns",
        icon: <Circle size={12} />,
        navLink: RETURNS_PATH,
        ...navPerm(PERMISSION_MODULE.PRODUCT_RETURN),
      },
      {
        id: "cancellation-policies",
        title: "Cancellation Policies",
        icon: <Circle size={12} />,
        navLink: CANCELLATION_POLICIES_PATH,
        ...navPerm(PERMISSION_MODULE.CANCELLATION_POLICY),
      },
      {
        id: "invoices",
        title: "Invoices & Documents",
        icon: <Circle size={12} />,
        navLink: INVOICES_PATH,
        ...navPerm(PERMISSION_MODULE.INVOICE),
      },
      {
        id: "payouts",
        title: "Payouts to Businesses",
        icon: <Circle size={12} />,
        navLink: PAYOUTS_PATH,
        ...navPerm(PERMISSION_MODULE.PAYOUT),
      },
    ],
  },
  {
    id: "analytics-reporting",
    title: "Analytics & Reporting",
    icon: <BarChart2 size={20} />,
    children: [
      {
        id: "analytics-dashboard",
        title: "Reporting Dashboard",
        icon: <Circle size={12} />,
        navLink: ANALYTICS_DASHBOARD_PATH,
        ...navPerm(PERMISSION_MODULE.REPORTING_DASHBOARD),
      },
      {
        id: "analytics-reports",
        title: "Reports",
        icon: <Circle size={12} />,
        navLink: REPORTS_PATH,
        ...navPerm(PERMISSION_MODULE.REPORT),
      },
      {
        id: "scheduled-reports",
        title: "Scheduled Reports",
        icon: <Circle size={12} />,
        navLink: SCHEDULED_REPORTS_PATH,
        ...navPerm(PERMISSION_MODULE.SCHEDULED_REPORT),
      },
      {
        id: "data-exports",
        title: "Data Exports",
        icon: <Circle size={12} />,
        navLink: DATA_EXPORTS_PATH,
        ...navPerm(PERMISSION_MODULE.DATA_EXPORT),
      },
    ],
  },
];
